import i18n from './compacted.json'

export default i18n;
